<template>
  <div class="utterance-dialog">
    <b-form @submit.prevent="addUtterance">

      <b-input-group class="mt-2 mb-2">
        <b-form-input v-model="utterance" autocomplete="off"></b-form-input>
        <b-input-group-append>
          <b-button variant="primary" v-on:click.prevent="addUtterance"><b-icon icon="chat-fill" font-scale="1.4"></b-icon></b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'AddUtterance',
  data () {
    return {
        utterance: ''
    }
  },
  created: function () {
  },
  methods: {
    addUtterance () {
      if( this.utterance ) {

        this.$store.dispatch('addUtterance', { 'text': this.utterance});

        this.utterance = '';

      }
    }
  },
}
</script>

<style scoped>

</style>
